/**
 * LT Info API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams, HttpResponse, HttpEvent, HttpParameterCodec, HttpContext }       from '@angular/common/http';
import { CustomHttpParameterCodec }                          from '../encoder';
import { Observable }                                        from 'rxjs';

// @ts-ignore
import { AccumulationZoneImageResponse } from '../model/accumulation-zone-image-response';
// @ts-ignore
import { AccumulationZoneImageUpdateRequest } from '../model/accumulation-zone-image-update-request';
// @ts-ignore
import { AccumulationZoneListResponse } from '../model/accumulation-zone-list-response';
// @ts-ignore
import { AccumulationZoneStepRequest } from '../model/accumulation-zone-step-request';
// @ts-ignore
import { AccumulationZoneStepResponse } from '../model/accumulation-zone-step-response';
// @ts-ignore
import { AssessmentInformationStepRequest } from '../model/assessment-information-step-request';
// @ts-ignore
import { AssessmentInformationStepResponse } from '../model/assessment-information-step-response';
// @ts-ignore
import { RoadSegmentAssessmentDetailDto } from '../model/road-segment-assessment-detail-dto';
// @ts-ignore
import { RoadSegmentAssessmentDto } from '../model/road-segment-assessment-dto';
// @ts-ignore
import { RoadSegmentAssessmentGridRow } from '../model/road-segment-assessment-grid-row';
// @ts-ignore
import { RoadSegmentAssessmentUpsertRequest } from '../model/road-segment-assessment-upsert-request';
// @ts-ignore
import { RoadSegmentAssessmentWorkflowProgressDto } from '../model/road-segment-assessment-workflow-progress-dto';
// @ts-ignore
import { ScoreStepRequest } from '../model/score-step-request';
// @ts-ignore
import { ScoreStepResponse } from '../model/score-step-response';

// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';
import { BaseService } from '../api.base.service';



@Injectable({
  providedIn: 'root'
})
export class RoadSegmentAssessmentService extends BaseService {

    constructor(protected httpClient: HttpClient, @Optional() @Inject(BASE_PATH) basePath: string|string[], @Optional() configuration?: Configuration) {
        super(basePath, configuration);
    }

    /**
     * @param roadSegmentAssessmentID 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public createAccumulationZoneRoadSegmentAssessment(roadSegmentAssessmentID: number, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json', context?: HttpContext, transferCache?: boolean}): Observable<AccumulationZoneStepResponse>;
    public createAccumulationZoneRoadSegmentAssessment(roadSegmentAssessmentID: number, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<AccumulationZoneStepResponse>>;
    public createAccumulationZoneRoadSegmentAssessment(roadSegmentAssessmentID: number, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<AccumulationZoneStepResponse>>;
    public createAccumulationZoneRoadSegmentAssessment(roadSegmentAssessmentID: number, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (roadSegmentAssessmentID === null || roadSegmentAssessmentID === undefined) {
            throw new Error('Required parameter roadSegmentAssessmentID was null or undefined when calling createAccumulationZoneRoadSegmentAssessment.');
        }

        let localVarHeaders = this.defaultHeaders;

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'text/plain',
            'application/json',
            'text/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/road-segment-assessments/${this.configuration.encodeParam({name: "roadSegmentAssessmentID", value: roadSegmentAssessmentID, in: "path", style: "simple", explode: false, dataType: "number", dataFormat: "int32"})}/workflow/steps/accumulation-zones`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<AccumulationZoneStepResponse>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * @param roadSegmentID 
     * @param assessmentInformationStepRequest 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public createNewAssessmentRoadSegmentAssessment(roadSegmentID: number, assessmentInformationStepRequest?: AssessmentInformationStepRequest, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json', context?: HttpContext, transferCache?: boolean}): Observable<RoadSegmentAssessmentDto>;
    public createNewAssessmentRoadSegmentAssessment(roadSegmentID: number, assessmentInformationStepRequest?: AssessmentInformationStepRequest, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<RoadSegmentAssessmentDto>>;
    public createNewAssessmentRoadSegmentAssessment(roadSegmentID: number, assessmentInformationStepRequest?: AssessmentInformationStepRequest, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<RoadSegmentAssessmentDto>>;
    public createNewAssessmentRoadSegmentAssessment(roadSegmentID: number, assessmentInformationStepRequest?: AssessmentInformationStepRequest, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (roadSegmentID === null || roadSegmentID === undefined) {
            throw new Error('Required parameter roadSegmentID was null or undefined when calling createNewAssessmentRoadSegmentAssessment.');
        }

        let localVarHeaders = this.defaultHeaders;

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'text/plain',
            'application/json',
            'text/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/road-segment-assessments/new/${this.configuration.encodeParam({name: "roadSegmentID", value: roadSegmentID, in: "path", style: "simple", explode: false, dataType: "number", dataFormat: "int32"})}`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<RoadSegmentAssessmentDto>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: assessmentInformationStepRequest,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * @param roadSegmentAssessmentUpsertRequest 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public createRoadSegmentAssessment(roadSegmentAssessmentUpsertRequest?: RoadSegmentAssessmentUpsertRequest, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json', context?: HttpContext, transferCache?: boolean}): Observable<RoadSegmentAssessmentDto>;
    public createRoadSegmentAssessment(roadSegmentAssessmentUpsertRequest?: RoadSegmentAssessmentUpsertRequest, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<RoadSegmentAssessmentDto>>;
    public createRoadSegmentAssessment(roadSegmentAssessmentUpsertRequest?: RoadSegmentAssessmentUpsertRequest, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<RoadSegmentAssessmentDto>>;
    public createRoadSegmentAssessment(roadSegmentAssessmentUpsertRequest?: RoadSegmentAssessmentUpsertRequest, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {

        let localVarHeaders = this.defaultHeaders;

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'text/plain',
            'application/json',
            'text/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/road-segment-assessments`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<RoadSegmentAssessmentDto>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: roadSegmentAssessmentUpsertRequest,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * @param roadSegmentAssessmentID 
     * @param accumulationZoneID 
     * @param imageID 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public deleteAccumulationZoneImageRoadSegmentAssessment(roadSegmentAssessmentID: number, accumulationZoneID: number, imageID: number, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<any>;
    public deleteAccumulationZoneImageRoadSegmentAssessment(roadSegmentAssessmentID: number, accumulationZoneID: number, imageID: number, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<any>>;
    public deleteAccumulationZoneImageRoadSegmentAssessment(roadSegmentAssessmentID: number, accumulationZoneID: number, imageID: number, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<any>>;
    public deleteAccumulationZoneImageRoadSegmentAssessment(roadSegmentAssessmentID: number, accumulationZoneID: number, imageID: number, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (roadSegmentAssessmentID === null || roadSegmentAssessmentID === undefined) {
            throw new Error('Required parameter roadSegmentAssessmentID was null or undefined when calling deleteAccumulationZoneImageRoadSegmentAssessment.');
        }
        if (accumulationZoneID === null || accumulationZoneID === undefined) {
            throw new Error('Required parameter accumulationZoneID was null or undefined when calling deleteAccumulationZoneImageRoadSegmentAssessment.');
        }
        if (imageID === null || imageID === undefined) {
            throw new Error('Required parameter imageID was null or undefined when calling deleteAccumulationZoneImageRoadSegmentAssessment.');
        }

        let localVarHeaders = this.defaultHeaders;

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/road-segment-assessments/${this.configuration.encodeParam({name: "roadSegmentAssessmentID", value: roadSegmentAssessmentID, in: "path", style: "simple", explode: false, dataType: "number", dataFormat: "int32"})}/workflow/steps/accumulation-zones/${this.configuration.encodeParam({name: "accumulationZoneID", value: accumulationZoneID, in: "path", style: "simple", explode: false, dataType: "number", dataFormat: "int32"})}/images/${this.configuration.encodeParam({name: "imageID", value: imageID, in: "path", style: "simple", explode: false, dataType: "number", dataFormat: "int32"})}`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<any>('delete', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * @param roadSegmentAssessmentID 
     * @param accumulationZoneID 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public deleteAccumulationZoneRoadSegmentAssessment(roadSegmentAssessmentID: number, accumulationZoneID: number, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<any>;
    public deleteAccumulationZoneRoadSegmentAssessment(roadSegmentAssessmentID: number, accumulationZoneID: number, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<any>>;
    public deleteAccumulationZoneRoadSegmentAssessment(roadSegmentAssessmentID: number, accumulationZoneID: number, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<any>>;
    public deleteAccumulationZoneRoadSegmentAssessment(roadSegmentAssessmentID: number, accumulationZoneID: number, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (roadSegmentAssessmentID === null || roadSegmentAssessmentID === undefined) {
            throw new Error('Required parameter roadSegmentAssessmentID was null or undefined when calling deleteAccumulationZoneRoadSegmentAssessment.');
        }
        if (accumulationZoneID === null || accumulationZoneID === undefined) {
            throw new Error('Required parameter accumulationZoneID was null or undefined when calling deleteAccumulationZoneRoadSegmentAssessment.');
        }

        let localVarHeaders = this.defaultHeaders;

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/road-segment-assessments/${this.configuration.encodeParam({name: "roadSegmentAssessmentID", value: roadSegmentAssessmentID, in: "path", style: "simple", explode: false, dataType: "number", dataFormat: "int32"})}/workflow/steps/accumulation-zones/${this.configuration.encodeParam({name: "accumulationZoneID", value: accumulationZoneID, in: "path", style: "simple", explode: false, dataType: "number", dataFormat: "int32"})}`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<any>('delete', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * @param roadSegmentAssessmentID 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public deleteRoadSegmentAssessment(roadSegmentAssessmentID: number, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<any>;
    public deleteRoadSegmentAssessment(roadSegmentAssessmentID: number, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<any>>;
    public deleteRoadSegmentAssessment(roadSegmentAssessmentID: number, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<any>>;
    public deleteRoadSegmentAssessment(roadSegmentAssessmentID: number, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (roadSegmentAssessmentID === null || roadSegmentAssessmentID === undefined) {
            throw new Error('Required parameter roadSegmentAssessmentID was null or undefined when calling deleteRoadSegmentAssessment.');
        }

        let localVarHeaders = this.defaultHeaders;

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/road-segment-assessments/${this.configuration.encodeParam({name: "roadSegmentAssessmentID", value: roadSegmentAssessmentID, in: "path", style: "simple", explode: false, dataType: "number", dataFormat: "int32"})}`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<any>('delete', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * @param roadSegmentAssessmentID 
     * @param accumulationZoneID 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getAccumulationZoneRoadSegmentAssessment(roadSegmentAssessmentID: number, accumulationZoneID: number, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json', context?: HttpContext, transferCache?: boolean}): Observable<AccumulationZoneStepResponse>;
    public getAccumulationZoneRoadSegmentAssessment(roadSegmentAssessmentID: number, accumulationZoneID: number, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<AccumulationZoneStepResponse>>;
    public getAccumulationZoneRoadSegmentAssessment(roadSegmentAssessmentID: number, accumulationZoneID: number, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<AccumulationZoneStepResponse>>;
    public getAccumulationZoneRoadSegmentAssessment(roadSegmentAssessmentID: number, accumulationZoneID: number, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (roadSegmentAssessmentID === null || roadSegmentAssessmentID === undefined) {
            throw new Error('Required parameter roadSegmentAssessmentID was null or undefined when calling getAccumulationZoneRoadSegmentAssessment.');
        }
        if (accumulationZoneID === null || accumulationZoneID === undefined) {
            throw new Error('Required parameter accumulationZoneID was null or undefined when calling getAccumulationZoneRoadSegmentAssessment.');
        }

        let localVarHeaders = this.defaultHeaders;

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'text/plain',
            'application/json',
            'text/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/road-segment-assessments/${this.configuration.encodeParam({name: "roadSegmentAssessmentID", value: roadSegmentAssessmentID, in: "path", style: "simple", explode: false, dataType: "number", dataFormat: "int32"})}/workflow/steps/accumulation-zones/${this.configuration.encodeParam({name: "accumulationZoneID", value: accumulationZoneID, in: "path", style: "simple", explode: false, dataType: "number", dataFormat: "int32"})}`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<AccumulationZoneStepResponse>('get', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * @param roadSegmentAssessmentID 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getAccumulationZonesListRoadSegmentAssessment(roadSegmentAssessmentID: number, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json', context?: HttpContext, transferCache?: boolean}): Observable<AccumulationZoneListResponse>;
    public getAccumulationZonesListRoadSegmentAssessment(roadSegmentAssessmentID: number, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<AccumulationZoneListResponse>>;
    public getAccumulationZonesListRoadSegmentAssessment(roadSegmentAssessmentID: number, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<AccumulationZoneListResponse>>;
    public getAccumulationZonesListRoadSegmentAssessment(roadSegmentAssessmentID: number, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (roadSegmentAssessmentID === null || roadSegmentAssessmentID === undefined) {
            throw new Error('Required parameter roadSegmentAssessmentID was null or undefined when calling getAccumulationZonesListRoadSegmentAssessment.');
        }

        let localVarHeaders = this.defaultHeaders;

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'text/plain',
            'application/json',
            'text/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/road-segment-assessments/${this.configuration.encodeParam({name: "roadSegmentAssessmentID", value: roadSegmentAssessmentID, in: "path", style: "simple", explode: false, dataType: "number", dataFormat: "int32"})}/workflow/steps/accumulation-zones`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<AccumulationZoneListResponse>('get', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * @param roadSegmentAssessmentID 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getAssessmentInformationStepRoadSegmentAssessment(roadSegmentAssessmentID: number, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json', context?: HttpContext, transferCache?: boolean}): Observable<AssessmentInformationStepResponse>;
    public getAssessmentInformationStepRoadSegmentAssessment(roadSegmentAssessmentID: number, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<AssessmentInformationStepResponse>>;
    public getAssessmentInformationStepRoadSegmentAssessment(roadSegmentAssessmentID: number, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<AssessmentInformationStepResponse>>;
    public getAssessmentInformationStepRoadSegmentAssessment(roadSegmentAssessmentID: number, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (roadSegmentAssessmentID === null || roadSegmentAssessmentID === undefined) {
            throw new Error('Required parameter roadSegmentAssessmentID was null or undefined when calling getAssessmentInformationStepRoadSegmentAssessment.');
        }

        let localVarHeaders = this.defaultHeaders;

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'text/plain',
            'application/json',
            'text/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/road-segment-assessments/${this.configuration.encodeParam({name: "roadSegmentAssessmentID", value: roadSegmentAssessmentID, in: "path", style: "simple", explode: false, dataType: "number", dataFormat: "int32"})}/workflow/steps/assessment-information`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<AssessmentInformationStepResponse>('get', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * @param roadSegmentAssessmentID 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getDetailRoadSegmentAssessment(roadSegmentAssessmentID: number, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json', context?: HttpContext, transferCache?: boolean}): Observable<RoadSegmentAssessmentDetailDto>;
    public getDetailRoadSegmentAssessment(roadSegmentAssessmentID: number, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<RoadSegmentAssessmentDetailDto>>;
    public getDetailRoadSegmentAssessment(roadSegmentAssessmentID: number, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<RoadSegmentAssessmentDetailDto>>;
    public getDetailRoadSegmentAssessment(roadSegmentAssessmentID: number, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (roadSegmentAssessmentID === null || roadSegmentAssessmentID === undefined) {
            throw new Error('Required parameter roadSegmentAssessmentID was null or undefined when calling getDetailRoadSegmentAssessment.');
        }

        let localVarHeaders = this.defaultHeaders;

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'text/plain',
            'application/json',
            'text/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/road-segment-assessments/${this.configuration.encodeParam({name: "roadSegmentAssessmentID", value: roadSegmentAssessmentID, in: "path", style: "simple", explode: false, dataType: "number", dataFormat: "int32"})}/detail`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<RoadSegmentAssessmentDetailDto>('get', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * @param roadSegmentID 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getNewAssessmentOptionsRoadSegmentAssessment(roadSegmentID: number, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json', context?: HttpContext, transferCache?: boolean}): Observable<AssessmentInformationStepResponse>;
    public getNewAssessmentOptionsRoadSegmentAssessment(roadSegmentID: number, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<AssessmentInformationStepResponse>>;
    public getNewAssessmentOptionsRoadSegmentAssessment(roadSegmentID: number, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<AssessmentInformationStepResponse>>;
    public getNewAssessmentOptionsRoadSegmentAssessment(roadSegmentID: number, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (roadSegmentID === null || roadSegmentID === undefined) {
            throw new Error('Required parameter roadSegmentID was null or undefined when calling getNewAssessmentOptionsRoadSegmentAssessment.');
        }

        let localVarHeaders = this.defaultHeaders;

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'text/plain',
            'application/json',
            'text/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/road-segment-assessments/new/${this.configuration.encodeParam({name: "roadSegmentID", value: roadSegmentID, in: "path", style: "simple", explode: false, dataType: "number", dataFormat: "int32"})}/options`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<AssessmentInformationStepResponse>('get', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * @param roadSegmentAssessmentID 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getRoadSegmentAssessment(roadSegmentAssessmentID: number, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json', context?: HttpContext, transferCache?: boolean}): Observable<RoadSegmentAssessmentDto>;
    public getRoadSegmentAssessment(roadSegmentAssessmentID: number, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<RoadSegmentAssessmentDto>>;
    public getRoadSegmentAssessment(roadSegmentAssessmentID: number, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<RoadSegmentAssessmentDto>>;
    public getRoadSegmentAssessment(roadSegmentAssessmentID: number, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (roadSegmentAssessmentID === null || roadSegmentAssessmentID === undefined) {
            throw new Error('Required parameter roadSegmentAssessmentID was null or undefined when calling getRoadSegmentAssessment.');
        }

        let localVarHeaders = this.defaultHeaders;

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'text/plain',
            'application/json',
            'text/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/road-segment-assessments/${this.configuration.encodeParam({name: "roadSegmentAssessmentID", value: roadSegmentAssessmentID, in: "path", style: "simple", explode: false, dataType: "number", dataFormat: "int32"})}`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<RoadSegmentAssessmentDto>('get', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * @param roadSegmentAssessmentID 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getScoreStepRoadSegmentAssessment(roadSegmentAssessmentID: number, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json', context?: HttpContext, transferCache?: boolean}): Observable<ScoreStepResponse>;
    public getScoreStepRoadSegmentAssessment(roadSegmentAssessmentID: number, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<ScoreStepResponse>>;
    public getScoreStepRoadSegmentAssessment(roadSegmentAssessmentID: number, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<ScoreStepResponse>>;
    public getScoreStepRoadSegmentAssessment(roadSegmentAssessmentID: number, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (roadSegmentAssessmentID === null || roadSegmentAssessmentID === undefined) {
            throw new Error('Required parameter roadSegmentAssessmentID was null or undefined when calling getScoreStepRoadSegmentAssessment.');
        }

        let localVarHeaders = this.defaultHeaders;

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'text/plain',
            'application/json',
            'text/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/road-segment-assessments/${this.configuration.encodeParam({name: "roadSegmentAssessmentID", value: roadSegmentAssessmentID, in: "path", style: "simple", explode: false, dataType: "number", dataFormat: "int32"})}/workflow/steps/score`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<ScoreStepResponse>('get', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * @param roadSegmentAssessmentID 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getWorkflowProgressRoadSegmentAssessment(roadSegmentAssessmentID: number, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json', context?: HttpContext, transferCache?: boolean}): Observable<RoadSegmentAssessmentWorkflowProgressDto>;
    public getWorkflowProgressRoadSegmentAssessment(roadSegmentAssessmentID: number, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<RoadSegmentAssessmentWorkflowProgressDto>>;
    public getWorkflowProgressRoadSegmentAssessment(roadSegmentAssessmentID: number, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<RoadSegmentAssessmentWorkflowProgressDto>>;
    public getWorkflowProgressRoadSegmentAssessment(roadSegmentAssessmentID: number, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (roadSegmentAssessmentID === null || roadSegmentAssessmentID === undefined) {
            throw new Error('Required parameter roadSegmentAssessmentID was null or undefined when calling getWorkflowProgressRoadSegmentAssessment.');
        }

        let localVarHeaders = this.defaultHeaders;

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'text/plain',
            'application/json',
            'text/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/road-segment-assessments/${this.configuration.encodeParam({name: "roadSegmentAssessmentID", value: roadSegmentAssessmentID, in: "path", style: "simple", explode: false, dataType: "number", dataFormat: "int32"})}/workflow/progress`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<RoadSegmentAssessmentWorkflowProgressDto>('get', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public listRoadSegmentAssessment(observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json', context?: HttpContext, transferCache?: boolean}): Observable<Array<RoadSegmentAssessmentGridRow>>;
    public listRoadSegmentAssessment(observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<Array<RoadSegmentAssessmentGridRow>>>;
    public listRoadSegmentAssessment(observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<Array<RoadSegmentAssessmentGridRow>>>;
    public listRoadSegmentAssessment(observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {

        let localVarHeaders = this.defaultHeaders;

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'text/plain',
            'application/json',
            'text/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/road-segment-assessments`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<Array<RoadSegmentAssessmentGridRow>>('get', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * @param roadSegmentAssessmentID 
     * @param accumulationZoneID 
     * @param accumulationZoneStepRequest 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public saveAccumulationZoneRoadSegmentAssessment(roadSegmentAssessmentID: number, accumulationZoneID: number, accumulationZoneStepRequest?: AccumulationZoneStepRequest, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<any>;
    public saveAccumulationZoneRoadSegmentAssessment(roadSegmentAssessmentID: number, accumulationZoneID: number, accumulationZoneStepRequest?: AccumulationZoneStepRequest, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<any>>;
    public saveAccumulationZoneRoadSegmentAssessment(roadSegmentAssessmentID: number, accumulationZoneID: number, accumulationZoneStepRequest?: AccumulationZoneStepRequest, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<any>>;
    public saveAccumulationZoneRoadSegmentAssessment(roadSegmentAssessmentID: number, accumulationZoneID: number, accumulationZoneStepRequest?: AccumulationZoneStepRequest, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (roadSegmentAssessmentID === null || roadSegmentAssessmentID === undefined) {
            throw new Error('Required parameter roadSegmentAssessmentID was null or undefined when calling saveAccumulationZoneRoadSegmentAssessment.');
        }
        if (accumulationZoneID === null || accumulationZoneID === undefined) {
            throw new Error('Required parameter accumulationZoneID was null or undefined when calling saveAccumulationZoneRoadSegmentAssessment.');
        }

        let localVarHeaders = this.defaultHeaders;

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/road-segment-assessments/${this.configuration.encodeParam({name: "roadSegmentAssessmentID", value: roadSegmentAssessmentID, in: "path", style: "simple", explode: false, dataType: "number", dataFormat: "int32"})}/workflow/steps/accumulation-zones/${this.configuration.encodeParam({name: "accumulationZoneID", value: accumulationZoneID, in: "path", style: "simple", explode: false, dataType: "number", dataFormat: "int32"})}`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<any>('put', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: accumulationZoneStepRequest,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * @param roadSegmentAssessmentID 
     * @param assessmentInformationStepRequest 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public saveAssessmentInformationStepRoadSegmentAssessment(roadSegmentAssessmentID: number, assessmentInformationStepRequest?: AssessmentInformationStepRequest, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<any>;
    public saveAssessmentInformationStepRoadSegmentAssessment(roadSegmentAssessmentID: number, assessmentInformationStepRequest?: AssessmentInformationStepRequest, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<any>>;
    public saveAssessmentInformationStepRoadSegmentAssessment(roadSegmentAssessmentID: number, assessmentInformationStepRequest?: AssessmentInformationStepRequest, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<any>>;
    public saveAssessmentInformationStepRoadSegmentAssessment(roadSegmentAssessmentID: number, assessmentInformationStepRequest?: AssessmentInformationStepRequest, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (roadSegmentAssessmentID === null || roadSegmentAssessmentID === undefined) {
            throw new Error('Required parameter roadSegmentAssessmentID was null or undefined when calling saveAssessmentInformationStepRoadSegmentAssessment.');
        }

        let localVarHeaders = this.defaultHeaders;

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/road-segment-assessments/${this.configuration.encodeParam({name: "roadSegmentAssessmentID", value: roadSegmentAssessmentID, in: "path", style: "simple", explode: false, dataType: "number", dataFormat: "int32"})}/workflow/steps/assessment-information`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<any>('put', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: assessmentInformationStepRequest,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * @param roadSegmentAssessmentID 
     * @param scoreStepRequest 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public saveScoreStepRoadSegmentAssessment(roadSegmentAssessmentID: number, scoreStepRequest?: ScoreStepRequest, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<any>;
    public saveScoreStepRoadSegmentAssessment(roadSegmentAssessmentID: number, scoreStepRequest?: ScoreStepRequest, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<any>>;
    public saveScoreStepRoadSegmentAssessment(roadSegmentAssessmentID: number, scoreStepRequest?: ScoreStepRequest, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<any>>;
    public saveScoreStepRoadSegmentAssessment(roadSegmentAssessmentID: number, scoreStepRequest?: ScoreStepRequest, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (roadSegmentAssessmentID === null || roadSegmentAssessmentID === undefined) {
            throw new Error('Required parameter roadSegmentAssessmentID was null or undefined when calling saveScoreStepRoadSegmentAssessment.');
        }

        let localVarHeaders = this.defaultHeaders;

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/road-segment-assessments/${this.configuration.encodeParam({name: "roadSegmentAssessmentID", value: roadSegmentAssessmentID, in: "path", style: "simple", explode: false, dataType: "number", dataFormat: "int32"})}/workflow/steps/score`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<any>('put', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: scoreStepRequest,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * @param roadSegmentAssessmentID 
     * @param accumulationZoneID 
     * @param imageID 
     * @param accumulationZoneImageUpdateRequest 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public updateAccumulationZoneImageRoadSegmentAssessment(roadSegmentAssessmentID: number, accumulationZoneID: number, imageID: number, accumulationZoneImageUpdateRequest?: AccumulationZoneImageUpdateRequest, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<any>;
    public updateAccumulationZoneImageRoadSegmentAssessment(roadSegmentAssessmentID: number, accumulationZoneID: number, imageID: number, accumulationZoneImageUpdateRequest?: AccumulationZoneImageUpdateRequest, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<any>>;
    public updateAccumulationZoneImageRoadSegmentAssessment(roadSegmentAssessmentID: number, accumulationZoneID: number, imageID: number, accumulationZoneImageUpdateRequest?: AccumulationZoneImageUpdateRequest, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<any>>;
    public updateAccumulationZoneImageRoadSegmentAssessment(roadSegmentAssessmentID: number, accumulationZoneID: number, imageID: number, accumulationZoneImageUpdateRequest?: AccumulationZoneImageUpdateRequest, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (roadSegmentAssessmentID === null || roadSegmentAssessmentID === undefined) {
            throw new Error('Required parameter roadSegmentAssessmentID was null or undefined when calling updateAccumulationZoneImageRoadSegmentAssessment.');
        }
        if (accumulationZoneID === null || accumulationZoneID === undefined) {
            throw new Error('Required parameter accumulationZoneID was null or undefined when calling updateAccumulationZoneImageRoadSegmentAssessment.');
        }
        if (imageID === null || imageID === undefined) {
            throw new Error('Required parameter imageID was null or undefined when calling updateAccumulationZoneImageRoadSegmentAssessment.');
        }

        let localVarHeaders = this.defaultHeaders;

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/road-segment-assessments/${this.configuration.encodeParam({name: "roadSegmentAssessmentID", value: roadSegmentAssessmentID, in: "path", style: "simple", explode: false, dataType: "number", dataFormat: "int32"})}/workflow/steps/accumulation-zones/${this.configuration.encodeParam({name: "accumulationZoneID", value: accumulationZoneID, in: "path", style: "simple", explode: false, dataType: "number", dataFormat: "int32"})}/images/${this.configuration.encodeParam({name: "imageID", value: imageID, in: "path", style: "simple", explode: false, dataType: "number", dataFormat: "int32"})}`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<any>('put', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: accumulationZoneImageUpdateRequest,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * @param roadSegmentAssessmentID 
     * @param roadSegmentAssessmentUpsertRequest 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public updateRoadSegmentAssessment(roadSegmentAssessmentID: number, roadSegmentAssessmentUpsertRequest?: RoadSegmentAssessmentUpsertRequest, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json', context?: HttpContext, transferCache?: boolean}): Observable<RoadSegmentAssessmentDto>;
    public updateRoadSegmentAssessment(roadSegmentAssessmentID: number, roadSegmentAssessmentUpsertRequest?: RoadSegmentAssessmentUpsertRequest, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<RoadSegmentAssessmentDto>>;
    public updateRoadSegmentAssessment(roadSegmentAssessmentID: number, roadSegmentAssessmentUpsertRequest?: RoadSegmentAssessmentUpsertRequest, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<RoadSegmentAssessmentDto>>;
    public updateRoadSegmentAssessment(roadSegmentAssessmentID: number, roadSegmentAssessmentUpsertRequest?: RoadSegmentAssessmentUpsertRequest, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (roadSegmentAssessmentID === null || roadSegmentAssessmentID === undefined) {
            throw new Error('Required parameter roadSegmentAssessmentID was null or undefined when calling updateRoadSegmentAssessment.');
        }

        let localVarHeaders = this.defaultHeaders;

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'text/plain',
            'application/json',
            'text/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/road-segment-assessments/${this.configuration.encodeParam({name: "roadSegmentAssessmentID", value: roadSegmentAssessmentID, in: "path", style: "simple", explode: false, dataType: "number", dataFormat: "int32"})}`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<RoadSegmentAssessmentDto>('put', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: roadSegmentAssessmentUpsertRequest,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * @param roadSegmentAssessmentID 
     * @param accumulationZoneID 
     * @param file 
     * @param caption 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public uploadAccumulationZoneImageRoadSegmentAssessment(roadSegmentAssessmentID: number, accumulationZoneID: number, file?: Blob, caption?: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json', context?: HttpContext, transferCache?: boolean}): Observable<AccumulationZoneImageResponse>;
    public uploadAccumulationZoneImageRoadSegmentAssessment(roadSegmentAssessmentID: number, accumulationZoneID: number, file?: Blob, caption?: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<AccumulationZoneImageResponse>>;
    public uploadAccumulationZoneImageRoadSegmentAssessment(roadSegmentAssessmentID: number, accumulationZoneID: number, file?: Blob, caption?: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<AccumulationZoneImageResponse>>;
    public uploadAccumulationZoneImageRoadSegmentAssessment(roadSegmentAssessmentID: number, accumulationZoneID: number, file?: Blob, caption?: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (roadSegmentAssessmentID === null || roadSegmentAssessmentID === undefined) {
            throw new Error('Required parameter roadSegmentAssessmentID was null or undefined when calling uploadAccumulationZoneImageRoadSegmentAssessment.');
        }
        if (accumulationZoneID === null || accumulationZoneID === undefined) {
            throw new Error('Required parameter accumulationZoneID was null or undefined when calling uploadAccumulationZoneImageRoadSegmentAssessment.');
        }

        let localVarHeaders = this.defaultHeaders;

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'text/plain',
            'application/json',
            'text/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;

        // to determine the Content-Type header
        const consumes: string[] = [
            'multipart/form-data'
        ];

        const canConsumeForm = this.canConsumeForm(consumes);

        let localVarFormParams: { append(param: string, value: any): any; };
        let localVarUseForm = false;
        let localVarConvertFormParamsToString = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        // see https://stackoverflow.com/questions/4007969/application-x-www-form-urlencoded-or-multipart-form-data
        localVarUseForm = canConsumeForm;
        if (localVarUseForm) {
            localVarFormParams = new FormData();
        } else {
            localVarFormParams = new HttpParams({encoder: this.encoder});
        }

        if (file !== undefined) {
            localVarFormParams = localVarFormParams.append('file', <any>file) as any || localVarFormParams;
        }
        if (caption !== undefined) {
            localVarFormParams = localVarFormParams.append('caption', <any>caption) as any || localVarFormParams;
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/road-segment-assessments/${this.configuration.encodeParam({name: "roadSegmentAssessmentID", value: roadSegmentAssessmentID, in: "path", style: "simple", explode: false, dataType: "number", dataFormat: "int32"})}/workflow/steps/accumulation-zones/${this.configuration.encodeParam({name: "accumulationZoneID", value: accumulationZoneID, in: "path", style: "simple", explode: false, dataType: "number", dataFormat: "int32"})}/images`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<AccumulationZoneImageResponse>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: localVarConvertFormParamsToString ? localVarFormParams.toString() : localVarFormParams,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

}
